module.exports = __webpack_public_path__ + "img/logo.f56a4ebc.svg";